import React from 'react';
import PropTypes from 'prop-types';

import MenuApp from './menuApp';

const MenuEscriptori = (props) => {
    const { urlActual } = props;
    return (
        <MenuApp
            urlActual={urlActual}
            classeCssMenu='menu-escriptori'
            modeMenu='horizontal'
        />
    );
};

MenuEscriptori.propTypes = {
    urlActual: PropTypes.string
};

export default MenuEscriptori;



// WEBPACK FOOTER //
// ./src/components/capcalera/menu/menuEscriptori.js